// extracted by mini-css-extract-plugin
module.exports = {"rightShape":"CryptoHero_rightShape__8dGbg","mainImage":"CryptoHero_mainImage__wJEqM","columnText":"CryptoHero_columnText__KnBwg"};